import React from "react"

/** Basic UI component to show a success message */
interface SuccessBannerProps {
  message: string
}
export const SuccessBanner: React.FC<SuccessBannerProps> = ({ message }) => {
  return (
    <div role="status" aria-live="polite" className="success !p-2 mb-4">
      {message}
    </div>
  )
}

/**
 * Basic UI component for a neutral notice (`.notice`, not `.info`, which is a
 * layout class on the org/recipe pages). Unlike the success/error banners it
 * takes children, so it can carry an action (see the onboarding slot).
 */
export const NoticeBanner: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return (
    <div role="status" aria-live="polite" className="notice !p-2 mb-4">
      {children}
    </div>
  )
}

/** Basic UI component to show an error message */
interface ErrorBannerProps {
  error: string
}
export const ErrorBanner: React.FC<ErrorBannerProps> = ({ error }) => {
  return (
    <div role="status" aria-live="polite" className="error !p-2 mb-4">
      {error}
    </div>
  )
}

/** Basic UI component to show a success or error message */
interface MessageSuccess {
  type: "success"
  message: string
}
interface MessageError {
  type: "error"
  error: string
}
export type MessageBannerData = MessageSuccess | MessageError
interface MessageBannerProps {
  data: MessageBannerData | null
}
export const MessageBanner: React.FC<MessageBannerProps> = ({ data }) => {
  if (!data) {
    return
  }
  if (data.type === "error") {
    return <ErrorBanner error={data.error} />
  }
  return <SuccessBanner message={data.message} />
}
